import { differenceInSeconds } from 'date-fns'
import { isEmpty, findLastKey } from 'lodash-es'

// Libs
import { setState, setNotificationList } from '@/redux/reducers/socket'

// Constants
import { WS_EVENT, WS_EVENT_SHOP_STATE } from '@/constants/socketEvent'
import { ROLE } from '@/constants/role'
import { NOTIFICATION_ACTION, ROOM_LIVE_TYPE } from '@/constants/liveRoom'

// Types
import { IMessage } from '../handleMessageReceive'
import { STORAGE_DATA } from '@/constants/storageData'

const ADD_TO_CART_BUFF_MINUTE = 2

const shopState = {
  action({ message, notificationList, roomData, userToken, t }: IMessage) {
    if (message?.ssid === WS_EVENT_SHOP_STATE.state) {
      if (message?.body?.type === WS_EVENT.STATE) {
        return handleStateReceive({ message })
      } else if (message?.body?.type === WS_EVENT.USERIN) {
        return handleUserIn({ message, notificationList, roomData, t })
      } else if (message?.body?.type === WS_EVENT.ADD2CART) {
        return handleAddToCartReceive({ message, notificationList, userToken })
      }
    }
  },
}

export default shopState

const handleStateReceive = ({ message }: IMessage) => {
  const data = message.body
  const { content } = data
  const { pub_products, top_products, views } = content

  const stateData = {
    views: views > 0 ? views : 0,
    topProductList: top_products?.length > 0 ? top_products : [],
    publishProductList: pub_products?.length > 0 ? pub_products : [],
  }

  return setState({ stateData })
}

const handleUserIn = ({ message, notificationList, roomData, t }: IMessage) => {
  const data = message.body

  const isFuture = roomData?.liveType === ROOM_LIVE_TYPE.FUTURE

  if (isFuture) return
  if (data.from.role === ROLE.HOST) return // 直播主自己進直播間不跳訊息

  const notificationListLength = notificationList?.length || 0

  const index: number = notificationListLength === 0 ? 1 : notificationList[notificationListLength - 1].index + 1

  const notificationData = {
    index,
    name: data?.from?.name,
    context: t('LiveRoom_Chat_Flag_User_In'),
    type: NOTIFICATION_ACTION.USER_IN,
    isShow: false,
    userId: data?.from?.userId,
    timestamp: data?.from?.timestamp,
  }

  return setNotificationList({ notificationData })
}

const handleAddToCartReceive = ({ message, notificationList, userToken }: IMessage) => {
  const data = message.body

  if (data.from.role === ROLE.HOST) return // 直播主自己進直播間不跳訊息

  const notificationListLength = notificationList?.length || 0

  const index = notificationListLength === 0 ? 1 : notificationList[notificationListLength - 1].index + 1

  const shoppingcartId = window.localStorage.getItem(STORAGE_DATA.SHOPPINGCART_ID)
  const userId = userToken || shoppingcartId

  const messageUserId = data?.from?.sender

  const isSelf = userId === messageUserId

  if (!isSelf) {
    // reference : http://tp-jira.tutorabc.com/browse/SHOP-535
    // 避免同一用戶大量加入不同SKU刷畫面，2分鐘內其他用戶只會看到一次某一用戶的購買事件 (不分SKU)，但該用戶可以看到每次事件
    const lastNotificationIndex: any = findLastKey(notificationList, { userId: messageUserId })
    const lastNotification = notificationList[lastNotificationIndex]

    const secondsDiff = lastNotification ? differenceInSeconds(new Date().getTime(), lastNotification?.timestamp) : 0
    const isLessThenTwoMinutes = secondsDiff < 60 * ADD_TO_CART_BUFF_MINUTE

    if (!isEmpty(lastNotification) && isLessThenTwoMinutes) return
  }

  const notificationData = {
    index,
    name: data?.from?.name,
    context: data.content?.prod_name,
    type: NOTIFICATION_ACTION.PURCHASE,
    isShow: false,
    userId: messageUserId,
    timestamp: new Date().getTime(),
  }

  return setNotificationList({ notificationData })
}
